var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnarchive = function SvgUnarchive(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M21.417 7.7A1.751 1.751 0 0 0 22.75 6V4A1.75 1.75 0 0 0 21 2.25H3A1.75 1.75 0 0 0 1.25 4v2c0 .823.568 1.513 1.333 1.7V19a2.75 2.75 0 0 0 2.75 2.75h13.334a2.75 2.75 0 0 0 2.75-2.75V7.7ZM3 3.75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h18a.25.25 0 0 0 .25-.25V4a.25.25 0 0 0-.25-.25H3Zm16.917 4H4.083V19c0 .69.56 1.25 1.25 1.25h13.334c.69 0 1.25-.56 1.25-1.25V7.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M11.47 11.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-.72-.72v2.54a.75.75 0 0 1-1.5 0v-2.54l-.72.72a.75.75 0 1 1-1.06-1.06l2-2Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnarchive);
export default ForwardRef;